import { render, staticRenderFns } from "./DisciplineSection.vue?vue&type=template&id=77e17cf3&scoped=true&"
import script from "./DisciplineSection.vue?vue&type=script&lang=js&"
export * from "./DisciplineSection.vue?vue&type=script&lang=js&"
import style0 from "./DisciplineSection.vue?vue&type=style&index=0&id=77e17cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e17cf3",
  null
  
)

export default component.exports